// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2WvMP","label":"LabeledBox_label__L3nu_"};